import { render } from "./jobTab2.vue?vue&type=template&id=5ba0617e"
import script from "./jobTab2.vue?vue&type=script&lang=js"
export * from "./jobTab2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__